"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("./constants");
var service_error_classification_1 = require("@aws-sdk/service-error-classification");
function defaultRetryDecider(retryClockSkewErrors) {
    if (retryClockSkewErrors === void 0) { retryClockSkewErrors = false; }
    return function (error) {
        if (!error) {
            return false;
        }
        if (error.connectionError) {
            return true;
        }
        if (hasMetadata(error) &&
            error.$metadata.httpStatusCode &&
            constants_1.RETRYABLE_STATUS_CODES.has(error.$metadata.httpStatusCode)) {
            return true;
        }
        return (service_error_classification_1.isStillProcessingError(error) ||
            service_error_classification_1.isThrottlingError(error) ||
            (retryClockSkewErrors && service_error_classification_1.isClockSkewError(error)));
    };
}
exports.defaultRetryDecider = defaultRetryDecider;
function hasMetadata(error) {
    return error && error.$metadata;
}
//# sourceMappingURL=retryDecider.js.map